import { useCallback, useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

export default function useTable<T>(table: string, orderBy = 'sort_order', filters?: Record<string, string | number | boolean>) {
  const [data, setData] = useState<T[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      let query = supabase.from(table).select('*');
      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          query = query.eq(key, value);
        });
      }
      const { data: rows, error: err } = await query.order(orderBy, { ascending: true });
      if (err) throw err;
      setData((rows as T[]) || []);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Unable to load content.');
    } finally {
      setLoading(false);
    }
  }, [table, orderBy, filters]);

  useEffect(() => { load(); }, [load]);

  return { data, loading, error, reload: load };
}